<template>
    <div class="table-responsive">
        <table class="table table-striped">
            <thead class="">
                <tr>
                    <th width="85px" style="vertical-align: center !important; text-align:center !important;">Mês/Ano</th>
                    <th style="text-align:left !important;">Súmula</th>
                    <th width="113px" style="text-align:center !important;">Diário Oficial</th>
                    <th width="113px" style="text-align:center !important;">Data Diário</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="itens in dadosconteudo.tr">
                    <td v-if="itens.mesano != ''" :rowspan="itens.rowspan" style="vertical-align: top !important;text-align:center !important;">{{itens.mesano}}</td>
                    <td style="text-align:left !important;"><a title="Arquivo Contas Publicas" :href="itens.linksumula" target="_blank">{{itens.sumula}}</a></td>
                    <td style="text-align:center !important;">{{itens.datadiario}}</td>
                    <td style="text-align:center !important;">{{itens.diariooficial}}</td>
                </tr>
            </tbody>
        </table>

        <div class="text-center">
            <cp-paginate :source="dadosconteudo" @navigate="navigate"><cp-paginate>
                    </div>
                    </div>
                    <!-- Modal de informações -->
                    <!-- fim Modal de informações -->
                    </template>
                    <script>
                        import CpPaginate from '../../pagination/pagination.vue'

                                export default{
                                    data() {
                                        return{
                                            dadostable: {}
                                        }
                                    },
                                    components: {
                                        CpPaginate
                                    },
                                    ready() {
                                        $('.table-responsive').fadeOut('fast');
                                    },
                                    watch: {
                                        $route() {
                                            $('.table-responsive').fadeOut('fast');
                                        }
                                    },
                                    props: ['dadosconteudo'],
                                    methods: {
                                        navigate(page) {
                                            $.ajaxSetup({
                                                async: false
                                            });

                                            var self = this

                                            $.getJSON('./src/components/tables/table-t5/datatable2v2.json', function (dados)
                                            {
                                                //self.dadosconteudo = dados[0];
                                                self.dadosconteudo = dados[0];
                                                self.dadostable = dados[0];
                                                //alert(self.$route.params.tipo)
                                                //console.log(dados[0].conteudo)
                                            });

                                            $.ajaxSetup({
                                                async: true
                                            });

                                        }
                                    }
                                }
                    </script>
                    <style scoped>

                    </style>



// WEBPACK FOOTER //
// table.vue?d80bd94c